import React from 'react';

// project-imports
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';
import { useCoursesContext } from '../../context/courses_context';
import SEO from '../../common/SEO';
import FooterOne from '../../common/footer/FooterOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AboutUsChannel from '../../components/about/AboutUsChannel';
import AboutUsOneService from '../../components/about-us-one/AboutUsOneService';
import HeaderLandingPage from '../../common/header/HeaderLandingPage';
import AboutUsPageSection from '../../components/about/AboutUsPageSection';
import HomeTwoTestimonial from '../../components/home-two/HomeTwoTestimonial';
import HeaderTwo from '../../common/header/HeaderTwo';
import SalesforceOffering from '../../components/salesforce/SalesforceOffering';

const AboutUs = () => {

    // Extracting method from context
    const { setFilteredCourses } = useCoursesContext();

    return (
        <>
            <SEO title="About Us | Longswitch Academy" url={process.env.PUBLIC_URL + "/about-us"} /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.ABOUT_US)}

            {/* <HeaderLandingPage setFilteredCourses={setFilteredCourses} searchDisable={true} /> */}
            <HeaderTwo setFilteredCourses={setFilteredCourses} searchDisable={true} />

            <BreadcrumbOne
                title="About Us" // Breadcrumb title 
                rootUrl="/"
                parentUrl="Home"
                currentUrl="About Us"
            />

            {/* About component */}
            <AboutUsPageSection />

            {/* Service component */}
            <AboutUsOneService />

            {/* Channel component */}
            <AboutUsChannel />

            {/* Testimonial component */}
            {/* <HomeTwoTestimonial /> */}
            <SalesforceOffering />

            {/* Footer component */}
            <FooterOne />
        </>
    )
}

export default AboutUs;